import React from 'react';
import { injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import SmsMethodList from '../../../components/SiteAdmin/SmsMethod/SmsMethodList';
import Loader from '../../../components/Common/Loader/Loader';

import { getAllSmsMethod } from '../../../lib/graphql';
import messages from '../../../locale/messages';
import { withQuery } from '../../../hoc/withGraphql';

class SmsMethod extends React.Component {

  render() {
    const { formatMessage } = this.props.intl;
    const { smsMethods, smsMethods: { loading } } = this.props;
    return (
      <Loader type={"page"} show={loading}>
        <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.manageSmsMethod)}</h1>
        {!loading && <SmsMethodList smsMethods={smsMethods} />}
      </Loader>
    );
  }
}

export default compose(
  injectIntl,
  withQuery(getAllSmsMethod, {
    name: 'smsMethods',
    options: {
      ssr: false,
      fetchPolicy: 'network-only'
    }
  }),)(SmsMethod);
